import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "./context/AppContext";
import Login from "./pages/Login";
import Layout from "./components/pm/Layout";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Tasks from "./pages/Tasks";
import Documents from "./pages/Documents";
import { Team, Customers } from "./pages/People";

function Shell() {
  const { user } = useApp();
  if (!user) return <Login />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/team" element={<Team />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <Shell />
          <Toaster position="bottom-right" richColors={false} toastOptions={{ className: "font-sans" }} />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
